import React from "react";
import { Box, Tab } from "@mui/material";
import { TabList } from "@mui/lab";
import FolderIcon from "@mui/icons-material/Folder";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useTranslation } from "react-i18next";
import { TabsType } from "../types";

type AgentTabsProps = {
  tab: TabsType;
  isCreate: boolean;
  onChange: (_event: React.SyntheticEvent, newValue: TabsType) => void;
};

const AgentTabs = ({ isCreate, onChange }: AgentTabsProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <TabList onChange={onChange} variant="fullWidth">
        <Tab
          label={t("createAgent.tabs.form")}
          value="default"
          icon={<AccountBoxIcon />}
          iconPosition="start"
          sx={{ minHeight: 48, padding: "12px 16px" }}
        />

        <Tab
          label={t("createAgent.tabs.rekviz")}
          value="rekviz"
          disabled={isCreate}
          icon={<VerifiedIcon />}
          iconPosition="start"
          sx={{ minHeight: 48, padding: "12px 16px" }}
        />

        <Tab
          label={t("createAgent.tabs.files")}
          value="files"
          disabled={isCreate}
          icon={<FolderIcon />}
          iconPosition="start"
          sx={{ minHeight: 48, padding: "12px 16px" }}
        />
      </TabList>
    </Box>
  );
};

export default AgentTabs;
